import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Loading from 'src/assets/images/Loading.svg'
import { SupportedBrands } from 'src/enums'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { useWhitelabel } from 'src/utils/whitelabel.utils'
import { css } from 'styled-components'

interface LoadingRightFlyoutContentProps {
  className?: string
}

const LoadingRightFlyoutContent: React.FC<LoadingRightFlyoutContentProps> = (
  props,
): React.ReactElement => {
  const { whiteLabelIncludes } = useWhitelabel()
  const isExtendBrand = whiteLabelIncludes(SupportedBrands.Extend)
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <div
      css={css`
        flex-grow: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
        justify-content: center;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100vw;
        `)}
      `}
      className={props.className}
    >
      {isExtendBrand && (
        <img
          css={css`
            height: 120px;
            width: 90px;
          `}
          alt={translateSingleString(locale, 'Loading')}
          src={Loading}
        />
      )}
      {!isExtendBrand && (
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.cta,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns source={'Loading...'} />
        </span>
      )}
    </div>
  )
}

export default LoadingRightFlyoutContent
